import {ButtonAction, clipboardService, ExtAddButton, LayoutContentTitle} from "@dv5/components"
import {DvTask, ItemAction, LayoutContentType, getViewItemUrl, useAppSelector} from '@dv5/domain'
import React, {FC} from "react"
import {taskApi} from "./services/taskService"
import './TaskHeader.less'

interface Props {
    task: DvTask
    layoutId: string
    onShowPopup: (show: boolean) => void
    onSelectLayout: () => void
}

export const TaskHeader: FC<Props> = ({
                                          task,
                                          layoutId,
                                          onShowPopup,
                                          onSelectLayout,
                                      }) => {
    const handleAction = (action: ItemAction) => {
        switch (action) {
            case ItemAction.COPY_URL:
                clipboardService.copyTo(getViewItemUrl(window.location.origin, layoutId, task.id, LayoutContentType.TASK), false)
                return
            case ItemAction.COPY_ID:
                clipboardService.copyTo(task.id, false)
                return
        }
    }

    const actions: Array<ButtonAction> = [{
        text: 'Copy URL',
        action: ItemAction.COPY_URL,
    }, {
        text: 'Copy ID',
        action: ItemAction.COPY_ID,
    }]

    return (
        <>
            <LayoutContentTitle title={task.title} onSelect={onSelectLayout}/>
            <ExtAddButton actions={actions}
                          onAdd={handleAction}
                          tooltipText="Task actions"
                          onShowPopup={onShowPopup}
            />
        </>
    )
}
